import { render, staticRenderFns } from "./List.vue?vue&type=template&id=5635755a&scoped=true"
import script from "./List.vue?vue&type=script&setup=true&lang=js"
export * from "./List.vue?vue&type=script&setup=true&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=5635755a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5635755a",
  null
  
)

export default component.exports